import { generateId } from './generateId'
import { formatCLP, parseCLP } from './currency'

export const createEmptyContractedService = () => ({
  id: generateId(),
  service_types: [],
  frequency: '',
  billable_value: '',
  other_services: []
})

const getServiceTypesFromApi = (service) => {
  if (Array.isArray(service.service_types) && service.service_types.length) {
    return service.service_types
  }

  if (service.service_type) {
    return [service.service_type]
  }

  return []
}

// "Otros servicios" ahora soporta múltiples descripciones (other_services).
// Fallback: el campo legacy `description` (string único).
const getOtherServicesFromApi = (service) => {
  if (Array.isArray(service.other_services) && service.other_services.length) {
    return service.other_services.filter(Boolean)
  }

  if (service.description) {
    return [service.description]
  }

  return []
}

export const normalizeContractedServicesFromApi = (services = []) => {
  const list = (services || []).map((service) => ({
    id: generateId(),
    service_types: getServiceTypesFromApi(service),
    frequency: service.frequency ?? '',
    billable_value: formatCLP(service.billable_value),
    other_services: getOtherServicesFromApi(service)
  }))

  // Un solo box por cliente: garantizar siempre un registro.
  return list.length ? list : [createEmptyContractedService()]
}

export const formatContractedServicesForApi = (services = []) =>
  (services || [])
    .filter((service) => (service.service_types || []).length > 0)
    .map(({ service_types, frequency, billable_value, other_services }) => {
      const item = {
        service_types,
        frequency: Number(frequency),
        billable_value: parseCLP(billable_value)
      }

      if (service_types.includes('OTROS_SERVICIOS')) {
        item.other_services = (other_services || [])
          .map((text) => (text || '').trim())
          .filter(Boolean)
      }

      return item
    })
